import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import * as searchResultModel from '~/routes/search/initial/model'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'

// TODO: add content type related title for i18n
export function Title({
  contentType: _,
}: {
  contentType: string
}): JSX.Element {
  return <AppTitle t='search' />
}

const skin = era.skin('routes/search/results')

SearchResultsPage.displayName = 'SearchResultsPage'
export function SearchResultsPage(): JSX.Element {
  const isContentLoading = useUnit(searchResultModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className='search-page'>
        <ui.RenderSkin name='stickySearchBlock' />
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='results' />
          <ui.RenderSkin name='recommendedVods' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
